import './products-slider.component.pug'
import './products-slider.component.scss'

import { Swiper, Scrollbar, Mousewheel } from 'swiper'
Swiper.use([Scrollbar, Mousewheel])

document.querySelectorAll('.products-slider').forEach((root) => {
  const swiperElement = root.querySelector('.swiper-container')
  new Swiper(swiperElement, {
    slidesPerView: 1,
    spaceBetween: 10,
    edgeSwipeDetection: 'prevent',
    mousewheel: {
      forceToAxis: true
    },
    scrollbar: {
      el: swiperElement.querySelector('.swiper-scrollbar'),
      draggable: true
    },
    breakpoints: {
      1921: {
        slidesPerView: 4
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 2
      }
    }
  })
})
